"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 4.4c-2.677 0-4.858 2.192-4.858 4.911v3.741a3.75 3.75 0 0 1-1.385 2.916l-.286.232a.7.7 0 1 1-.882-1.087l.286-.232a2.35 2.35 0 0 0 .867-1.829v-3.74C5.742 5.831 8.538 3 12 3a6.2 6.2 0 0 1 4.008 1.465.7.7 0 0 1-.901 1.07A4.8 4.8 0 0 0 12 4.4m5.557 4.684a.7.7 0 0 1 .7.7v3.268c0 .713.32 1.385.868 1.83l.285.231c1.35 1.094.6 3.315-1.162 3.315H9.573a.7.7 0 1 1 0-1.4h8.675c.413 0 .629-.545.28-.828l-.285-.232a3.76 3.76 0 0 1-1.386-2.916V9.784a.7.7 0 0 1 .7-.7M9.45 20.3a.7.7 0 0 1 .7-.7h3.702a.7.7 0 1 1 0 1.4H10.15a.7.7 0 0 1-.7-.7M20.495 3.505a.7.7 0 0 1 0 .99l-16 16a.7.7 0 0 1-.99-.99l16-16a.7.7 0 0 1 .99 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BellAlertOffIcon24.js.map